import { ASSET_PREFIX } from 'utils/constants';

export type PrizeTierProps = {
  color: string;
  title: string;
  subtitle?: string;
  badge: string;
  poundSigns: {
    solid: string;
    faded: string;
  };
  order: number;
};

// prize tiers to be shown on user-facing prize pages
export const MAIN_DRAW_PRIZE_TIERS: Record<string, PrizeTierProps> = {
  DAYMAKERboost: {
    color: '#FF399E',
    title: 'DAYMAKER',
    subtitle: 'boost',
    badge: `${ASSET_PREFIX}/images/prizes/PrizeValueDropdownSelector/daymaker-boost.png`,
    poundSigns: {
      solid: '£££££',
      faded: '',
    },
    order: 10,
  },
  DAYMAKER: {
    color: '#00C4A7',
    title: 'DAYMAKER',
    badge: `${ASSET_PREFIX}/images/prizes/PrizeValueDropdownSelector/daymaker.png`,
    poundSigns: {
      solid: '££££',
      faded: '',
    },
    order: 9,
  },
  Diamond: {
    color: '#8430D6',
    title: 'Diamond',
    badge: `${ASSET_PREFIX}/images/prizes/PrizeValueDropdownSelector/diamond.png`,
    poundSigns: {
      solid: '£££',
      faded: '',
    },
    order: 8,
  },
  Platinum: {
    color: '#43BFE5',
    title: 'Platinum',
    badge: `${ASSET_PREFIX}/images/prizes/PrizeValueDropdownSelector/platinum.png`,
    poundSigns: {
      solid: '££',
      faded: '£',
    },
    order: 7,
  },
  Gold: {
    color: '#F7C366',
    title: 'Gold',
    badge: `${ASSET_PREFIX}/images/prizes/PrizeValueDropdownSelector/gold.png`,
    poundSigns: {
      solid: '££',
      faded: '',
    },
    order: 6,
  },
  Silver: {
    color: '#9D9594',
    title: 'Silver',
    badge: `${ASSET_PREFIX}/images/prizes/PrizeValueDropdownSelector/silver.png`,
    poundSigns: {
      solid: '£',
      faded: '£',
    },
    order: 5,
  },
  Bronze: {
    color: '#F99261',
    title: 'Bronze',
    badge: `${ASSET_PREFIX}/images/prizes/PrizeValueDropdownSelector/bronze.png`,
    poundSigns: {
      solid: '£',
      faded: '',
    },
    order: 4,
  },
  LEADERBOARD_RAFFLE: {
    color: '#00C4A7',
    title: 'Leaderboard Raffle',
    badge: `${ASSET_PREFIX}/images/leaderboard/leaderboard.png`,
    poundSigns: {
      solid: '',
      faded: '',
    },
    order: 3,
  },
};

export const getPrizeTierFullName = (prizeTierCode: string) =>
  MAIN_DRAW_PRIZE_TIERS[prizeTierCode]?.title +
  (MAIN_DRAW_PRIZE_TIERS[prizeTierCode]?.subtitle || '');

export const PRIZE_ASSET_BUCKET =
  'https://daymade-website-assets.s3.eu-west-1.amazonaws.com/2026/prizes';
